import { License } from "@/pages/settings/components/settingsItems/hooks/types";
import { Button } from "@/components/ui/button";
import LogoIconContainer from "@/components/ui/logo-icon-container";
import Text from "@/components/ui/text";
import { cn } from "@/utils/utils";
import React from "react";
import { useTranslation } from "react-i18next";

const TRANSLATION_KEY = "settings.product";

export interface ProductItemLayoutProps {
  index: number;
  productName: string;
  productId: string;
  licenses?: License[];
  onEditProduct: () => void;
}

const ProductItemLayout: React.FC<ProductItemLayoutProps> = ({
  index,
  productName,
  licenses,
  onEditProduct
}) => {
  const { t } = useTranslation();
  return (
    <div className={cn("w-full flex flex-col  items-start justify-center")}>
      <div className="flex flex-row px-4 py-3 w-full justify-between items-center">
        <div className="flex flex-row gap-4 items-center">
          <LogoIconContainer index={index} />
          <Text variant="body">{productName}</Text>
        </div>
        <Button variant="secondaryNoBg" onClick={onEditProduct}>
          {t(`${TRANSLATION_KEY}.edit`)}
        </Button>
      </div>
      <div className="border-b border-border-border1 w-full" />
      <div className="gap-6 p-4 flex flex-col">
        <div className="gap-6 flex flex-row">
          <div className="w-[148px]">
            <Text variant="bodySecondary">
              {t(`${TRANSLATION_KEY}.licenseTypeName`)}
            </Text>
          </div>
          <div className="w-[504px]">
            <Text variant="bodySecondary">
              {t(`${TRANSLATION_KEY}.licenseTypeDescription`)}
            </Text>
          </div>
        </div>

        {licenses &&
          licenses.map((license) => (
            <div key={license.name} className={"gap-6 flex flex-row"}>
              <div className="w-[148px]">
                <Text variant="body">{license.name}</Text>
              </div>
              <div className="w-[504px]">
                <Text variant="body">{license.description || "-"}</Text>
              </div>
            </div>
          ))}
      </div>
    </div>
  );
};

export default ProductItemLayout;
